import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	tabContent: {
		paddingTop: "30px"
	}
})

export default useStyles
